// axios
import axios from "axios";
import store from "@/store/index";
import router from '../router';

const baseURL = process.env.VUE_APP_KAVOSH_PATH;
export default class ApiServiceLayer {
  async get(url, service, headers = {}, queryStrings, isAuthorized = true) {
    // define variables for keep url and queryString
    let apiUrl = baseURL + "/" + service + url;
    let queryString = "";
    let fullHeaders = {};
    let token = store.state.userConfig.accessToken;
    //check for queryStrings parameter exist, if true save this in queryString variable
    if (queryStrings) {
      queryString = queryStrings;
    }

    if (token !== null || token !== undefined) {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          Authorization: token,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    } else {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    }

    try {
      // call api with axios and send apiUrl and queryString, save resuts in res variable
      const res = await axios.get(apiUrl + queryString, {
        headers: fullHeaders,
      });

      //check for code of response, if 200 set data.status to "OK" else set "ERROR"

      return res;
    } catch (error) {
      if (error.response.data.code === 401 || error.response.data.code === 403) {
				localStorage.removeItem('cp_pwa');
				store.commit('userConfig/clearAllConfigs');
				router.push('login');
			}
      return error.response;
    }
  }
  async auth_post(url, service, data, headers = {}, isAuthorized = true) {
    let apiUrl = baseURL + "/" + service + url;
    let fullHeaders = {};
    fullHeaders = {
      ...headers,
      "epms-client": "web-app",
    };
    try {
      const res = await axios.post(apiUrl, data, {
        headers: fullHeaders,
      });

      //check for code of response, if 200 set data.status to "OK" else set "ERROR"

      if (res.data.code === 200) {
        res.data.status = "OK";
        return res;
      } else if (res.data.code === 500) {
        res.data.status = "ERROR";
        return res;
      }

      return res;
    } catch (error) {
      if (error.response.data.code === 401 || error.response.data.code === 403) {
				localStorage.removeItem('cp_pwa');
				store.commit('userConfig/clearAllConfigs');
				router.push('login');
			}
      return error.response;
    }
  }

  async post(url, service, data, headers = {}, isAuthorized = true) {
    let apiUrl = baseURL + "/" + service + url;
    let fullHeaders = {};
    let token = store.state.userConfig.accessToken;

    if (token !== null || token !== undefined) {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          Authorization: token,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    } else {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    }

    try {
      const res = await axios.post(apiUrl, data, {
        headers: fullHeaders,
      });

      //check for code of response, if 200 set data.status to "OK" else set "ERROR"

      if (res.data.code === 200) {
        res.data.status = "OK";
        return res;
      } else if (res.data.code === 500) {
        res.data.status = "ERROR";
        return res;
      }

      return res;
    } catch (error) {
      if (error.response.data.code === 401 || error.response.data.code === 403) {
				localStorage.removeItem('cp_pwa');
				store.commit('userConfig/clearAllConfigs');
				router.push('login');
			}
      return error.response;
    }
  }

  async delete(url, service, headers = {}, isAuthorized = true) {
    // define variables for keep url and response
    let apiUrl = baseURL + "/" + service + url;
    let queryString = "";
    let fullHeaders = {};
    let token = store.state.userConfig.accessToken;

    //check for queryStrings parameter exist, if true save this in queryString variable
    // if (queryStrings) {
    // 	queryString = this.queryStringGenerator(queryStrings);
    // }

    if (token !== null || token !== undefined) {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          Authorization: token,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    } else {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    }

    try {
      const res = await axios.delete(apiUrl + queryString, {
        headers: fullHeaders,
      });
      //check for code of response, if 200 set data.status to "OK" else set "ERROR"
      return res;
    } catch (error) {
      if (error.response.data.code === 401 || error.response.data.code === 403) {
				localStorage.removeItem('cp_pwa');
				store.commit('userConfig/clearAllConfigs');
				router.push('login');
			}
    }
  }

  async put(url, service, data, headers = {}, isAuthorized = true) {
    let apiUrl = baseURL + "/" + service + url;
    let fullHeaders = {};
    let token = store.state.userConfig.accessToken;
    if (token !== null || token !== undefined) {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          Authorization: token,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    } else {
      if (isAuthorized) {
        fullHeaders = {
          ...headers,
          "epms-client": "web-app",
        };
      } else {
        fullHeaders = { "content-type": "application/json", ...headers };
      }
    }

    try {
      const res = await axios.put(apiUrl, data, {
        headers: fullHeaders,
      });

      //check for code of response, if 200 set data.status to "OK" else set "ERROR"

      if (res.data.code === 200) {
        res.data.status = "OK";
        return res;
      } else if (res.data.code === 500) {
        res.data.status = "ERROR";
        return res;
      }

      return res;
    } catch (error) {
      if (error.response.data.code === 401 || error.response.data.code === 403) {
				localStorage.removeItem('cp_pwa');
				store.commit('userConfig/clearAllConfigs');
				router.push('login');
			}
    }
  }
  async patch(url, service, data, headers = {}, isAuthorized = true) {
		let apiUrl = baseURL + "/" + service + url;
		let fullHeaders = {};
		let token = store.state.userConfig.accessToken;
		if (token) {
			if (isAuthorized) {
				fullHeaders = {
					...headers,
					Authorization: token,
					'epms-client': 'web-app',
				};
			} else {
				fullHeaders = { 'content-type': 'application/json', ...headers };
			}
		} else {
			if (isAuthorized) {
				fullHeaders = {
					...headers,
					'epms-client': 'web-app',
				};
			} else {
				fullHeaders = { 'content-type': 'application/json', ...headers };
			}
		}

		try {
			const res = await axios.patch(apiUrl, data, {
				headers: fullHeaders,
			});

			//check for code of response, if 200 set data.status to "OK" else set "ERROR"

			if (res.data.code === 200) {
				res.data.status = 'OK';
				return res;
			} else if (res.data.code === 500) {
				res.data.status = 'ERROR';
				return res;
			}
			return res;
		} catch (error) {
			if (error.response.status === 401 || error.response.status === 403) {
				router.push({ name: "login" });
			}
			return error;
		}
	}
  // method for generate query string, get an object and return the query string
  // queryStringGenerator(queryStringObj) {
  //   // define variables for keep queryString and index of item in itrerator
  //   let queryString = "";
  //   let indexOfQueryString = 0;

  //   for (let item in queryStringObj) {
  //     // check for item exist in queryStringObj
  //     if (queryStringObj.hasOwnProperty(item)) {
  //       indexOfQueryString += 1;

  //       // Because first query string is starts with '?' and the rest with '&'
  //       if (indexOfQueryString === 1) {
  //         queryString += "?" + item + "=" + queryStringObj[item];
  //       } else {
  //         queryString += "&" + item + "=" + queryStringObj[item];
  //       }
  //     }
  //   }

  //   return queryString;
  // }
}
